var map = {
	"./ccna.png": 4396,
	"./coursera-01.png": 8444,
	"./datacamp-01.png": 5039,
	"./iitg-01.png": 7213,
	"./iitg.png": 1217,
	"./ineuron-01.png": 6853,
	"./kaggle.png": 5674,
	"./problem-01.png": 9745,
	"./python-01.png": 1216,
	"./simplilearn-01.png": 1445,
	"./tabana-01.png": 279,
	"./tabcon-01.png": 863,
	"./udemy-01.png": 5012
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7047;